import { createRequest } from '../../services/request';

export enum TECHNICAL_INTERVENTIONS_ACTION_TYPE {
  GET_TECHNICAL_INTERVENTIONS_BY_FILE_ID = 'TECHNICAL_INTERVENTIONS/GET_TECHNICAL_INTERVENTIONS_BY_FILE_ID',
}

export const GET_TECHNICAL_INTERVENTIONS_BY_FILE_ID = createRequest(
  TECHNICAL_INTERVENTIONS_ACTION_TYPE.GET_TECHNICAL_INTERVENTIONS_BY_FILE_ID,
);
